app.controller("ExamsManagerEditSpecialController", [
    "$scope", "ExamsManagerService", "$uibModalInstance", "$state", "$timeout", "toastr", "params", "$filter",
    function ($scope, ExamsManagerService, $uibModalInstance, $state, $timeout, toastr, params, $filter) {
        console.log(params);
        var specialSubject = params.specialSubject;
        var sessionsList = [];
        $scope.sessions = [];
        $scope.specialSubjectSessions = specialSubject.sessions || [];

        function hasSession(subjectSession) {
            return $scope.specialSubjectSessions.indexOf(subjectSession) >= 0;
        }

        function reloadSessions() {
            $scope.sessions = [];
            // console.log($scope.specialSubjectSessions.length);
            sessionsList.forEach(function (item) {
                var name = $filter('date')(item.examDay.day, 'yyyy-MM-dd');
                name += " " + $filter('date')(item.time, 'HH-mm');
                name += " - " + item.examHall.name;
                // console.log(name);
                $scope.sessions.push({
                    _id: item._id,
                    name: name,
                    enabled: hasSession(item._id)
                });
            });
        }

        function fetchSessionsList() {
            ExamsManagerService.fetchSessions().then(function (sessions) {
                sessionsList = sessions;
                console.log(sessions);
                reloadSessions();
            });
        }

        fetchSessionsList();

        $scope.toggle = function (session) {
            var action = "add";
            if (session.enabled) {
                action = "remove";
            }
            console.log(action);
            ExamsManagerService.toggleSpecialSession({
                sessionId: session._id,
                specialSubjectId: specialSubject._id,
                action: action
            }).then(function (data) {
                $scope.specialSubjectSessions = data.sessions;
                console.log(data.sessions);
                reloadSessions();
            });

        };

        $scope.close = function () {
            $uibModalInstance.dismiss();
        };
    }
]);